import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
    pageOption: {
        margin: 0,
    },
    boxOption: {
        padding: '8px 12px',
        '&:hover': {
            background: '#CCC',
        },
    },
    dropDown: {
        position: 'absolute',
        top: '100%',
        width: '100%',
        overflowY: 'scroll',
        background: '#FFF',
        borderRadius: '8px',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        maxHeight: '80vh',
    },
}));
